<template>
  <div class="add-pay-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="450px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-form-item label="内容:" prop="content">
          <el-input v-model="params.content" type="textarea"></el-input>
        </el-form-item>
        <!-- <el-form-item label="跳转链接:" prop="url">
          <el-input v-model="params.url" style="width: 310px"></el-input>
        </el-form-item> -->
        <el-form-item label="跳转位置:" prop="url">
          <el-select
            v-model="params.url"
            size="small"
            placeholder="请选择位置"
            style="width:300px"
          >
            <el-option
              v-for="item in urlList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="位置:" prop="status">
          <el-select
            v-model="params.type"
            size="small"
            placeholder="请选择位置"
            style="width:300px"
          >
            <el-option
              v-for="item in types"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="激活状态:">
          <el-switch v-model="isActive" active-color="#13ce66"> </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addAnnounce, updateAnnounce } from "@/api/marquee.js";
// import { validateURL } from "@/utils/validator.js";

export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      flag: false,
      id: "",
      params: {
        content: "",
        url: "",
        type: "",
      },
      types: [
        {
          label: "首页banner下方",
          value: 1,
        },
        {
          label: "我的banner上方",
          value: 2,
        },
        // {
        //   label: "会员中心-vip卡下方",
        //   value: 3,
        // },
        {
          label: "社区子专题下方",
          value: 4,
        },
        {
          label: "猎奇模块banner广告位下方",
          value: 5,
        },
        {
          label: "私信顶部",
          value: 6,
        },
        {
          label: "片库",
          value: 7,
        },
        {
          label: "福利任务",
          value: 8,
        },
      ],
      urlList: [
        {
          label: "会员中心",
          value: "yinseinner://vip_page",
        },
        {
          label: "钱包",
          value: "yinseinner://wallet_page",
        },
        {
          label: "福利中心",
          value: "yinseinner://freeBenefits",
        },
        {
          label: "预售活动",
          value: "yinseinner://advancePage",
        },
      ],
      isActive: true,
      rules: {
        url: [{ required: true, message: "请选择跳转位置", trigger: "blur" }],
        content: [
          { required: true, message: "请输入公告内容", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 提交修改
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.title === "新增跑马灯配置") {
            this.addAnnounce();
          } else {
            this.updateAnnounce();
          }
        } else {
          return false;
        }
      });
    },
    // 修改跑马灯配置
    updateAnnounce() {
      // if (this.params.url !== "") {
      //   if (!validateURL(this.params.url)) {
      //     this.$message.warning("跳转链接不合法");
      //     return;
      //   }
      // }
      let params = Object.assign({}, this.params, {
        id: this.params.id,
        content: this.params.content,
        url: this.params.url,
        active: this.isActive,
      });
      updateAnnounce(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改跑马灯配置成功",
              type: "success",
            });
            this.$emit("queryMarquee");
          } else {
            this.$message.error("修改跑马灯配置失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 添加跑马灯配置
    addAnnounce() {
      // if (this.params.url !== "") {
      //   if (!validateURL(this.params.url)) {
      //     this.$message.warning("跳转链接不合法");
      //     return;
      //   }
      // }
      let params = Object.assign({}, this.params, {
        content: this.params.content,
        url: this.params.url,
        type: this.params.type,
        active: this.isActive,
      });
      addAnnounce(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增跑马灯配置成功",
              type: "success",
            });
            this.$emit("queryMarquee");
          } else {
            this.$message.error("跑马灯配置只能存在一条激活的数据");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          // this.$message.error('新增跑马灯配置失败');
          this.handleClose();
        });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        content: "",
        url: "",
      };
      this.isActive = true;
      // this.$refs['form'].resetFields()
    },
    // 打开新增、编辑弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      if (data) {
        this.params = data;
        this.isActive = data.active;
      }
      if (type === "edit") {
        this.title = "编辑跑马灯配置";
      } else {
        this.title = "新增跑马灯配置";
      }
    },
  },
};
</script>

<style lang="scss">
.add-pay-box {
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
